import axios from "api/axios";

// App Backend
export const getSubscriptionData = async () => {
  const response = await axios.get("/api/subscriptions/user/current");
  return response.data;
};
